import { render, staticRenderFns } from "./sosinterval_modal.vue?vue&type=template&id=54e74f57&scoped=true&"
import script from "./sosinterval_modal.vue?vue&type=script&lang=js&"
export * from "./sosinterval_modal.vue?vue&type=script&lang=js&"
import style0 from "./sosinterval_modal.vue?vue&type=style&index=0&id=54e74f57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e74f57",
  null
  
)

export default component.exports